import type { ReactNode } from "react";
import { environmentSymbols } from "../environment/section.js";
import { ENVIRONMENT_DELIVERY } from "../generated/environment-delivery.generated.js";

/** Approved Soft Wash still shared by landing and account surfaces. */
export function BloomBackground({ className = "" }: { className?: string | undefined }): ReactNode {
  const room = environmentSymbols().get("ink.room.k10-workshop-soft");
  const href = room?.markup.match(/<image\b[^>]*href="([^"]+)"/u)?.[1];
  const delivered = href === undefined ? undefined : ENVIRONMENT_DELIVERY[href]?.at(-1)?.href ?? href;
  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden bg-[#0a0a0a] ${className}`}
      style={{ backgroundImage: delivered === undefined ? undefined : `url(${delivered})`, backgroundSize: "cover", backgroundPosition: "center" }}
    >
      <div className="absolute inset-0 bg-black/70" />
    </div>
  );
}
